<template>
  <div>
    <div
      ref="appContent"
      class="app-content content"
      data-scrollbar
      :class="[{ 'show-overlay': $store.state.app.shallShowOverlay || $store.state.permissions.checkingInitialPermissions }, $route.meta.contentClass]"
    >

      <div class="content-overlay" />
      <div class="header-navbar-shadow" />
      <div
        class="content-wrapper pb-2"
        :class="contentWidth === 'boxed' ? 'container p-0' : null"
      >
        <slot name="breadcrumb">
          <app-breadcrumb />
        </slot>
        <div class="content-body overflow-hidden">
          <transition
            :name="routerTransition"
            mode="out-in"
          >
            <slot />
          </transition>
        </div>
      </div>
    </div>

    <portal-target name="lightbox" />
  </div>
</template>

<script>
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import useAppConfig from '@core/app-config/useAppConfig'
import { getUserData } from '@/auth/utils'
import { fcm } from '@/utils/fcm'
import { TOPICS } from '@/const/common'

export default {
  components: {
    AppBreadcrumb,
  },
  setup() {
    const self = getUserData()
    const { routerTransition, contentWidth } = useAppConfig()
    const topics = TOPICS

    return {
      routerTransition, contentWidth, topics, self,
    }
  },
  data() {
    return {
      scrollbar: null,
    }
  },
  mounted() {
    fcm(this.topics)
  },
}
</script>

<style scoped>
.app-content {
  height: 100vh;
}

.content-body {
  min-height: 70vh;
}
</style>
